import state from './state';
import Store from '../../base';

export default class NumberCircles extends Store {
    constructor(model, ng) {

        state.model = model;

        super({state, ng});
    }
}


// WEBPACK FOOTER //
// ./src/app/store/billing/number_circles/index.js